import { Box, Button, Grid, Typography } from '@mui/material';
import PageWrapper from 'components/Common/PageWraper';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchProductDetailsCatalog } from 'service/service';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import EditIcon from '@mui/icons-material/Edit';
import ProductDetailsCard from './ProductDetailsCard';
import LoaderComponent from 'components/Loader';
import CostDetailsCard from './CostDetailsCard';
import RecentRenewalsCard from './RecentRenewalsCard';

const ProductDetails = () => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const [productDetails, setProductDetails] = useState<any>(null);
	const [productLoadingState, setProductLoadingState] = useState({
		isProductDetailsLoading: true
	});

	const setProductLoading = (key: keyof typeof productLoadingState, value: boolean) => {
        setProductLoadingState(prev => ({
            ...prev,
            [key]: value,
        }));
    };

	const fetchProductDetailsData = useCallback(async () => {
		setProductLoading('isProductDetailsLoading', true);
		if (!id) return;
		try {
			const response = await fetchProductDetailsCatalog(id);
			if (response?.data) {
				setProductDetails(response.data);
			}
		} catch (error) {
			console.error('Error fetching catalogue data completeness:', error);
		} finally {
			setProductLoading('isProductDetailsLoading', false);
        }
	}, [id]);

	useEffect(() => {
		fetchProductDetailsData();
	}, [fetchProductDetailsData])

	return (
		<PageWrapper sx={{ mt: { xs: '78px', lg: '64px' } }}>
			<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<Button sx={{ display: 'flex', gap: '8px', alignItems: 'center' }} onClick={() => navigate(-1)}>
					<ArrowBackIosNewIcon sx={{ height: '24px', width: '24px', color: '#003771' }} />
					<Typography sx={{ color: '#003771', fontSize: '20px', fontWeight: '600' }}>
						{productDetails?.productName ?? 'Back'}
					</Typography>
				</Button>
				<Button
					disabled
					variant="pepwiseSecondary"
					sx={{ width: '8rem', display: 'flex', gap: '8px', alignItems: 'center' }}
				>
					<EditIcon sx={{ height: '16px', width: '16px' }} />
					<Typography sx={{ fontSize: '14px' }}>EDIT</Typography>
				</Button>
			</Box>
			<Grid container spacing={3} sx={{ mb: 3, pt: 3 }}>
				<Grid item xs={12} md={8}>
					{productLoadingState.isProductDetailsLoading ? (
						<LoaderComponent sx={{ background: '#ffffff', borderRadius: '8px' }} py={16} />
					) : (
						<ProductDetailsCard data={productDetails} />
					)}
				</Grid>
				<Grid item xs={12} md={4}>
					{productLoadingState.isProductDetailsLoading ? (
						<LoaderComponent sx={{ background: '#ffffff', borderRadius: '8px' }} py={16} />
					) : (
						<CostDetailsCard data={productDetails} />
					)}
				</Grid>
				<Grid item xs={12} md={8}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: '50vh',
							background: '#ffffff'
						}}
					>
						<Typography variant="h4" color={'#000000'}>
							Renewal History
						</Typography>
					</Box>
				</Grid>
				<Grid item xs={12} md={4}>
					{productLoadingState.isProductDetailsLoading ? (
						<LoaderComponent sx={{ background: '#ffffff', borderRadius: '8px' }} py={16} />
					) : (
						<RecentRenewalsCard data={productDetails} />
					)}
				</Grid>
			</Grid>
		</PageWrapper>
	);
};

export default ProductDetails;